<template>
    <div class="multi-step-filter-select-all f fa-c c-p show-hover"
        v-if="canSelectAll"
        :title="uiTooltip"
        @click.prevent.stop="onItemSelected">
        <FormCheckbox size="s"
            display="check"
            :value="isChecked"
            :intermediate="isPartiallyChecked"
            :uiStyle="uiCheckboxStyle"
            @input="onCheckChanged" />
        <div class="f fa-l fv sm-l-m el-title">
            <div class="fg">{{ 'mead.select_all' | athT }}</div>
        </div>
    </div>
</template>

<script>
import FormCheckbox from '../../atoms/forms/FormCheckbox.vue';

export default {
    components: {FormCheckbox},
    props: {
        /**
         * The current search query string. The "select all" control is only shown when this is
         * empty, since select-all does not make sense against a filtered/searched item list.
         */
        qstring: {type: String, default: ''},
        /**
         * The list of items visible in the current step that "select all" toggles. With group
         * selection all descendant values are toggled, otherwise only descendant leaf values.
         */
        items: {type: Array, default: () => []},
        /**
         * The filter engine instance holding the current selection and multi-select configuration
         * (isMultiMode, max, min, allowGroupSelection).
         */
        engine: {type: Object, default: () => {}}
    },
    methods: {
        onItemSelected: function () {
            this.onCheckChanged(!this.isChecked);
        },
        onCheckChanged: function (checked) {
            this.$emit('onCheck', this.engine.getSelectAllCheckedList(this.items, checked));
        }
    },
    computed: {
        // Computed from the current items so it stays correct when changing levels
        isChecked: function () {
            return this.engine.isAnySelected(this.items);
        },
        uiTooltip: function () {
            return MeadCommon.I18N.go('mead.select_all');
        },
        uiCheckboxStyle: function () {
            return this.isPartiallyChecked ? 'partial-default' : false;
        },
        isPartiallyChecked: function () {
            return this.engine.isAnySelected(this.items) && !this.engine.isAllSelected(this.items);
        },
        canSelectAll: function () {
            return this.engine.canSelectAll(this.items, this.qstring);
        },
    }
};
</script>
<style lang="scss" scoped>
@use '../../../../sass/variables' as *;
.multi-step-filter-select-all {
    letter-spacing: $ls-s;
    border-radius: $br-m;
    padding: 0.8rem $s-m;
    line-height: $lh-m;
    white-space: normal;
    transition: background-color 0.5s ease;

    &.show-hover {
        &:active,
        &:hover {
            background-color: var(--c-brand-light-bg);
        }
    }

    .el-title {
        min-width: 5%;
    }
}
</style>
